function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_8709)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 4.875C8.69239 4.875 10.875 3.86764 10.875 2.625C10.875 1.38236 8.69239 0.375 6 0.375C3.30761 0.375 1.125 1.38236 1.125 2.625C1.125 3.86764 3.30761 4.875 6 4.875Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.125 2.625C1.12561 3.72171 1.49613 4.78616 2.17663 5.64622C2.85712 6.50628 3.80783 7.11167 4.875 7.3645V10.5C4.875 10.7984 4.99353 11.0845 5.2045 11.2955C5.41548 11.5065 5.70163 11.625 6 11.625C6.29837 11.625 6.58452 11.5065 6.7955 11.2955C7.00647 11.0845 7.125 10.7984 7.125 10.5V7.3645C8.19217 7.11167 9.14288 6.50628 9.82337 5.64622C10.5039 4.78616 10.8744 3.72171 10.875 2.625",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_8709"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white"
})));

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c1ef4779.svg";
export { ForwardRef as ReactComponent };